import { Component, Input, Inject, PLATFORM_ID, Output } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { EventEmitter } from '@angular/core';
import { MktTaggingTransformationService } from 'src/app/core/services';


@Component({
  // tslint:disable-next-line: component-selector
  selector: 'ui-card-button',
  standalone: false,
  template: `<button cdsButton="primary" class="learn-more-btn {{getBtnSize()}} noMargin" [attr.data-id]="dataId+'-'+pid"
    [mktRouterLink]="btnLink" (click)="applyCard($event, btnLink)" [attr.tabindex]="tabIndex" type="button"
    (keyup.Enter)="applyCard($event, btnLink)" [attr.target]="hrefTarget"
    [attr.aria-label]="getAriaLabel() | adaFriendlyName: 'ariaLabel'"
    style="text-align: center;" [innerHTML]="btnName" [attr.role]="role"></button>`,
  styles: [`
  .btn {
    margin: 0;
    text-decoration:none;
  }
  ::ng-deep.small {
    margin: 0;
  }
  ::ng-deep.default {
    margin-right: 0 !important;
  }
  `],
})
export class CardButtonComponent {
  @Input() btnName: string;
  @Input() cardName: string;
  @Input() btnLink: string;
  @Input() pid: string;
  @Input() hashcode:string;
  @Input() tagText = '';
  @Input() tagEvent = 'customLinkClick';
  @Input() size = 767;
  @Input() tabIndex = 0;
  @Input() hrefTarget = '_self';
  @Input() role = 'button';
  @Input() page: string;
  @Input() dataId:string = 'applyNowUrl';
  @Output() clicked: EventEmitter<any> = new EventEmitter();

  constructor(
    private _mktTagging:MktTaggingTransformationService,
    @Inject(PLATFORM_ID) private platformId: string) { }

  applyCard(event, link) {
    if (isPlatformBrowser(this.platformId)) {
      if (this.page==="CCP") {
      let taggingDynamicProp = {
        category: 'cards:acquisition',
        product_name: "c:" + this.pid,
        acquisition_source_code: this.hashcode
      }
      this._mktTagging.tagMktCompareCards('compareApplyNowLink', {
        products: [taggingDynamicProp],
        pid: this.pid,
        link_name:'Apply Now',
      });
    }
      delete window['citiData'].ratingAndReviewDetail;
      window['citiData'].custLink = this.tagText;
      window['Bootstrapper'].ensEvent.trigger(this.tagEvent);
      this.clicked.emit(event);
    }
  }

  getBtnSize() {
    if (isPlatformBrowser(this.platformId)) {
      return window.innerWidth <= this.size ? `small` : `default`;
    } else { return `default`; }
  }

  getAriaLabel() {
    return `${this.cardName} ${this.btnName}`;
  }
}
